"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApptsUpToDateMsg = exports.NoMoreApptsMsg = exports.LoadMoreBtnContainer = exports.List = exports.ListHeader = exports.ApptButton = exports.ArrowButton = exports.Header = exports.Toolbar = exports.ApptContainer = exports.Container = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const framer_motion_1 = require("framer-motion");
const styled_1 = __importDefault(require("@emotion/styled"));
const button_1 = __importDefault(require("@kyruus/button"));
const breakpoints_1 = require("../../../lib/constants/breakpoints");
const EASE = 'ease-out';
const FAST = '0.3s';
const sticky = {
    header: {
        date: '80px',
        location: '125px'
    },
    mobileHeader: {
        date: '60px',
        location: '105px'
    }
};
exports.Container = (0, styled_1.default)('div') `
  background: white;
  width: 100%;

  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    width: calc(100% - ${breakpoints_1.SIDEBAR_WIDTH} - ${(0, ui_theme_1.fromTheme)('spacing_large')});
    margin-left: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  }
`;
exports.ApptContainer = (0, styled_1.default)('div') `
  ${({ isVirtualVisit, theme }) => isVirtualVisit &&
    `ul {
      margin-bottom: 0;
      margin-top: -1px;
    }
    div:nth-of-type(2) ul:first-of-type {
      margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')({ theme })};
    }

    div:last-of-type ul {
      margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')({ theme })};
    }`}
`;
exports.Toolbar = (0, styled_1.default)('div') `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;

  > * {
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  }

  > div {
    &:first-of-type {
      .SingleDatePicker_picker {
        z-index: 1000;
      }

      .SingleDatePickerInput_calendarIcon {
        color: ${(0, ui_theme_1.fromTheme)('color_link')};
      }

      .SingleDatePickerInput .DateInput {
        .DateInput_input:hover {
          border-bottom: 2px solid ${(0, ui_theme_1.fromTheme)('color_link')};
        }
        width: auto;

        .DateInput_input {
          color: ${(0, ui_theme_1.fromTheme)('color_link')};
          padding-left: 0;
          padding-right: 0;
          cursor: pointer;
          text-align: left;
          width: 100%;
          font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
          font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
        }
      }
    }
  }
`;
exports.Header = (0, styled_1.default)('div') `
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;

  ${(_a) => {
    var { disableExpandCollapse } = _a, restProps = __rest(_a, ["disableExpandCollapse"]);
    return disableExpandCollapse
        ? 'position: static;'
        : `position: sticky;
  z-index: 10;
  top: ${restProps.stickyValues
            ? restProps.stickyValues.mobileHeader.date
            : sticky.mobileHeader.date};
  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_xsmall')(restProps)}) {
    top: ${restProps.stickyValues
            ? restProps.stickyValues.header.date
            : sticky.header.date};
  }`;
}};

  h5 {
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
    font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
    margin: 0;
    padding: 2px 0 0 0;
  }
`;
exports.ArrowButton = (0, styled_1.default)(button_1.default) `
  svg {
    ${(props) => props.reversed && 'transform: rotate(180deg);'}
    transition: transform ${FAST} ${EASE};
  }
`;
exports.ApptButton = (0, styled_1.default)(button_1.default) ``;
exports.ListHeader = (0, styled_1.default)('div') `
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  padding-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  font-weight: normal;

  margin: 0;
  background: white;

  ${(_a) => {
    var { disableExpandCollapse } = _a, restProps = __rest(_a, ["disableExpandCollapse"]);
    return disableExpandCollapse
        ? 'position: static;'
        : `position: sticky;
  top: ${restProps.stickyValues
            ? restProps.stickyValues.mobileHeader.location
            : sticky.mobileHeader.location};
  @media (min-width: ${(0, ui_theme_1.fromTheme)('db_screen_xsmall')(restProps)}) {
    top: ${restProps.stickyValues
            ? restProps.stickyValues.header.location
            : sticky.header.location};
  }`;
}};

  > div:first-of-type {
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  }
`;
const stylesByDensity = {
    default: (props) => `
    li {
      flex: 1 0 100%;

      & > button {
        border: 1px solid ${(0, ui_theme_1.fromTheme)('color_border')(props)};
        border-top: none;
        padding: ${(0, ui_theme_1.fromTheme)('spacing_large')(props)} ${(0, ui_theme_1.fromTheme)('spacing_medium')(props)};
        color: ${(0, ui_theme_1.fromTheme)('color_text')(props)};
        &:hover {
          border-color: ${(0, ui_theme_1.fromTheme)('color_border')(props)};
        }
      }

      &:first-of-type > button {
        border-top: 1px solid ${(0, ui_theme_1.fromTheme)('color_border')(props)};
      }
    }
  `,
    dense: (props) => `
    gap: ${(0, ui_theme_1.fromTheme)('spacing_small')(props)};
    li {
      flex: 0 1 100px;
      & > button {
        padding: ${(0, ui_theme_1.fromTheme)('spacing_small')(props)};
      }
    }
  `
};
exports.List = (0, styled_1.default)(framer_motion_1.motion.ul) `
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: flex-start;
  list-style: none;
  padding: 0;
  flex: 1;
  margin: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0 ${(0, ui_theme_1.fromTheme)('spacing_xlarge')} 0;
  transition: max-height 0.2s ${EASE};
  overflow: hidden;

  li {
    & > button {
      margin: 0;
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }
  && {
    ${(_a) => {
    var { apptDensity } = _a, restProps = __rest(_a, ["apptDensity"]);
    return stylesByDensity[apptDensity](restProps);
}};
  }
`;
exports.LoadMoreBtnContainer = (0, styled_1.default)('div') `
  button {
    width: 100%;
  }
`;
exports.NoMoreApptsMsg = (0, styled_1.default)('div') `
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  text-align: center;
`;
exports.ApptsUpToDateMsg = (0, styled_1.default)('div') `
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  text-align: center;
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_small')};
`;
//# sourceMappingURL=styles.js.map